export default function ChevronDownIcon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" {...props}>
      <path d="M12 15.7l6-6-1.4-1.4-4.6 4.6-4.6-4.6L6 9.7l6 6z" fill="currentColor" />
    </svg>
  );
}

export const ChevronUpIcon = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" {...props}>
      <path d="M12 8.3l-6 6 1.4 1.4 4.6-4.6 4.6 4.6 1.4-1.4-6-6z" fill="currentColor" />
    </svg>
  );
};
